export var DIALOG_TITLE_CLASS_PREFIX = 'DialogTitle';
export var dialogTitleText = 'DialogTitleText';